import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ModalContent } from './../../models/modal-content.model';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private display: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  private modalSubject: BehaviorSubject<ModalContent> =
    new BehaviorSubject<ModalContent>({ title: '', content: '', buttons: [] });
  private confirmAction = new Subject<any>();

  modal$!: Observable<ModalContent>;
  confirmAction$!: Observable<any>;

  constructor() {
    this.modal$ = this.modalSubject.asObservable();
    this.confirmAction$ = this.confirmAction.asObservable();
  }

  watch() {
    return this.display.asObservable();
  }

  getData(data: ModalContent) {
    this.modalSubject.next(data);
  }

  confirm(): void {
    this.modal$.subscribe(data => {
      this.confirmAction.next(data.title);
    });
    this.close();
  }

  open() {
    this.display.next(true);
  }

  close() {
    this.display.next(false);
    this.confirmAction = new Subject<any>();
    this.confirmAction$ = this.confirmAction.asObservable();
  }
}
